import {FC} from "react";
import {
	GridToolbarContainer,
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport
} from "@mui/x-data-grid-pro";
import {Box} from "@mui/material";
import {makeStyles} from "tss-react/mui";

const useStyles = makeStyles()((_theme) => ({
	customToolbar: {
		display: "flex",
		gap: "10px",
		border: "0px solid"
	},
	gap: {
		flexGrow: 100
	}
}));

const filterInvalidButtonProps = <P extends Record<string, unknown>>(props: P) => {
	const {onPointerEnterCapture, onPointerLeaveCapture, onResize, onResizeCapture, ...rest} = props;
	return rest;
};

export const QuizzesListGridToolbar: FC<Record<string, unknown>> = (props) => {
	const {classes} = useStyles();
	const p = (props ?? {}) as Record<string, unknown>;
	const containerProps = filterInvalidButtonProps(p);
	const filteredProps = filterInvalidButtonProps(p);

	return (
		<GridToolbarContainer className={classes.customToolbar} {...containerProps}>
			<GridToolbarColumnsButton {...(filteredProps as any)} />
			<GridToolbarFilterButton {...(filteredProps as any)} />
			<GridToolbarExport {...(filteredProps as any)} />
			<Box className={classes.gap} />
		</GridToolbarContainer>
	);
};
